import React from "react";
import About2 from "./About2";

function About() {
  return (
    <div className="about-background activeNavlink" id="scrollAbout">
      <About2 />
    </div>
  );
}

export default About;
